import { Drawer, IconButton, Stack, Toolbar, Tooltip, Typography, useTheme } from "@mui/material";
import { Settings } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import UserFavoriteList, { UserFavoritesListRefType } from "../user-favorites-list/UserFavoritesList";
import { useRef } from "react";
import { AddIcon } from "../action-menu/ActionMenuIcons";
import { BaseActionEnum } from "../action-menu/ActionMenuItem";
import { EXECUTE_ACTION_TOPIC, ExecuteActionMsg } from "../../common/models/pub-sub/PubSubTopics";
import { publish } from "pubsub-js";
import { useAppHeaderContext } from "../../contexts/app-header-context/UseAppHeaderContext";
import { useEvaluateFeature } from "../../queries/features/UseEvaluateFeature";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { FeatureConstants } from "../../services/features-data-service/Models";
import PushPinButton from "../push-pin-button/PushPinButton";

export type UserFavoritesDrawerProps = {
    open: boolean;
    pinned?: boolean;
    onPinClick?: (() => void) | undefined;
    onClose?: () => void;
};

export default function UserFavoritesDrawer({
    open,
    pinned,
    onPinClick,
    onClose
}: UserFavoritesDrawerProps) {
    const theme = useTheme();
    const { t } = useTranslation();
    const userListRef = useRef<UserFavoritesListRefType>(null);

    const { data: headerAndActionsV2Feature } = useQueryNotifications(useEvaluateFeature)({
        feature: FeatureConstants.HeaderAndActionsV2,
    });

    const headerAndActionsV2 = (headerAndActionsV2Feature ?? false);


    const {
        appHeaderContextState, 
        //setRefreshActionState,
        //setExportActionState,
        //setFavoriteActionState
    } = useAppHeaderContext();


    function onManageFavoritesClick() {
        userListRef.current?.manageFavorites();
    }

    function onAddFavorite() {
        publish(EXECUTE_ACTION_TOPIC, {
            action: BaseActionEnum.Favorite
        } as ExecuteActionMsg);

    }

    return (
        <Drawer
            sx={{
                height: "100vh"
            }}
            variant="permanent"
            open={open}
            slotProps={{
                paper: {
                    sx: {
                        position: "relative",
                        whiteSpace: "nowrap",
                        maxWidth: theme.spacing(50),
                        [theme.breakpoints.down('xs')]: {
                            maxWidth: '100%'
                        },
                        transition: theme.transitions.create("width", {
                            easing: theme.transitions.easing.sharp,
                            duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
                        }),
                        width: !open ? theme.spacing(7) : theme.spacing(50),//'auto',
                        overflowX: !open ? 'hidden' : 'auto'
                    }
                }
            }}
        >
            <Toolbar />
            <Stack
                direction="column"
                sx={{
                    height: 1,
                    overflow: "hidden"
                }}
            >
                <Stack
                    direction="row"
                    sx={{
                        flex: " 0 0 auto",
                        alignItems: "center",
                        paddingLeft: 1
                    }}>
                    <Typography variant="subtitle1">
                        {t("userFavorites.title")}
                    </Typography>
                    {headerAndActionsV2 && <IconButton 
                        disabled={appHeaderContextState.favoriteActionEnabled !== true}
                        sx={{ 
                            marginLeft: "auto" 
                        }} 
                        onClick={() => onAddFavorite()}
                    >
                        <Tooltip title="Add Favorite">
                            {AddIcon()}
                        </Tooltip>
                        
                    </IconButton>}
                    <IconButton 
                        sx={{ 
                            marginLeft: !headerAndActionsV2 ? "auto" : undefined
                        }} 

                        onClick={() => onManageFavoritesClick()}>
                        <Settings />
                    </IconButton>
                    <PushPinButton
                        onClick={onPinClick}
                        pinned={pinned}
                    />
                </Stack>

                <UserFavoriteList
                    ref={userListRef}
                    enabled={open}
                    onClick={() => {
                        if(!pinned) {
                            onClose?.();
                        }
                    }}
                />
            </Stack>
        </Drawer >
    );
}
